import { defineComponent as _defineComponent } from 'vue'
import userManager from '@/auth';
import { computed, ref } from 'vue';
import useStore from '@/utils/store/common';
import UserProfile from './components/UserProfile.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Avatar',
  setup(__props) {

const store = useStore();
const showProfile = ref(false);
const getCurrentUserName = computed(() => store.getters['user/getCurrentUserName']);
const getCurrentUserRole = computed(() => store.getters['permissions/getCurrentUserRole']);

function displayProfileModal() {
  showProfile.value = !showProfile.value;
}

return { __sfc: true,store, showProfile, getCurrentUserName, getCurrentUserRole, displayProfileModal, userManager, UserProfile }
}

})